import { render, staticRenderFns } from "./showJiaobanDialog.vue?vue&type=template&id=ce2fe10e&scoped=true&"
import script from "./showJiaobanDialog.vue?vue&type=script&lang=js&"
export * from "./showJiaobanDialog.vue?vue&type=script&lang=js&"
import style0 from "./showJiaobanDialog.vue?vue&type=style&index=0&id=ce2fe10e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2fe10e",
  null
  
)

export default component.exports